import type { GenericError, RequestStatus } from '@skynet/data-ws-core';
import type { JsonLiquidityExchange } from '@skynet/data-liquidity-types';
import type { JsonBalanceAsset, JsonBalanceRaw } from '@skynet/types-balance';
import type { PricesItem } from '@skynet/types-price-item';

export enum RetainerOverviewCommands {
  // Wire command name as sent by the backend; kept verbatim as the contract.
  RetainerOverview = 'RetainerOverview',
}

/**
 * A single balance asset entry from the `RetainerOverview` WS payload.
 * Structurally identical to the shared `JsonBalanceAsset`
 * (`@skynet/types-balance`), so app-level code that still types
 * against `JsonBalance[]` accepts this without a cast.
 */
export type RetainerOverviewBalanceAsset = JsonBalanceAsset;

/**
 * A single balance entry from the `RetainerOverview` WS payload.
 * Structurally compatible with the app's `JsonBalance`
 * (`src/store/shared/balances/types`) — the `account` enrichment field is
 * intentionally omitted (it's optional there and never populated on this WS
 * path; account joining happens downstream, in app-level selectors).
 */
export interface RetainerOverviewBalance extends JsonBalanceRaw {
  exchangeID: number;
  accountName: string;
  exchangeName?: string;
  isWallet: boolean;
  updated?: string;
}

export interface JsonRetainerOverviewSuccess {
  command: RetainerOverviewCommands.RetainerOverview;
  exchanges: JsonLiquidityExchange[];
  balances: RetainerOverviewBalance[];
  pairs: string[];
  supportedExchanges: number[];
  prices: PricesItem[];
  coinGeckoLink: string;
}

export interface RetainerOverviewState {
  requestStatus: RequestStatus;
  error: null | GenericError;

  exchanges: JsonLiquidityExchange[];
  balances: RetainerOverviewBalance[] | null;

  supportedPairs: string[];
  supportedExchanges: number[];
  prices: PricesItem[];
  coinGeckoLink: string;
}
